export default "__VITE_ASSET__DBhYghZU__"